<template>
  <div>
    <v-row>
      <v-col>
        <v-card outlined color="grey darken-2" hover>
          <v-list-item two-line>
            <v-list-item-content>
              <div class="overline mb-6">X-RAY Servers</div>
              <v-list-item-title class="headline mb-1 text-right text-h3 green--text font-weight-bold">{{
                  x_ray_servers_count
                }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col>
        <v-card outlined color="grey darken-2" hover>
          <v-list-item two-line>
            <v-list-item-content>
              <div class="overline mb-6">Available X-RAY Servers</div>
              <v-list-item-title class="headline mb-1 text-right text-h3 green--text font-weight-bold">{{
                  x_ray_available_servers_count
                }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card outlined color="grey darken-3" hover>
          <v-list-item two-line>
            <v-list-item-content>
              <div class="overline mb-12">Teltower Servers</div>
              <v-list-item-title class="headline mb-1 text-right text-h3 green--text font-weight-bold">
                {{ teltower_servers_count }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
    <v-row></v-row>
    <v-row></v-row>
  </div>
</template>


<script>

export default {
  name: "server-data",
  data() {
    return {
      x_ray_servers_count: 0,
      x_ray_available_servers_count: 0,
      teltower_servers_count: 0,
      value: [],
    }
  },
  mounted() {
    this.axios.get('https://isee.sh:2087/servers/statistics').then(response => {
      this.x_ray_servers_count = numberWithCommas(response.data.x_ray_servers_count)
      this.x_ray_available_servers_count = numberWithCommas(response.data.x_ray_available_servers_count)
      this.teltower_servers_count = numberWithCommas(response.data.teltower_servers_count)
    })

  }
}

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

</script>

<style scoped>

</style>